import { ApiAlertResponse, ApiProject } from "@incendium/api";
import { alertService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchAlerts = async (selectedProject: ApiProject | null) => {
  if (selectedProject) {
    const alerts = await alertService.alertServiceListAlerts({
      projectId: selectedProject.id as number,
    });
    return alerts.results || [];
  }
  return [];
};

export const useAlerts = () => {
  const { state, setState } = useProjectSharedState("alerts", [], fetchAlerts);

  return {
    alerts: state as ApiAlertResponse[],
    setAlerts: setState,
  };
};
